module.exports = __webpack_public_path__ + "img/PT.ada259b5.svg";